import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';
import { ISetupStatusResponse } from '../../features/todos/models/setup-status.model';

export const setupStatusFeatureKey = 'setupStatus';

export interface SetupStatusState {
  loadSetupStatusResponse: ISetupStatusResponse;
}

export const initialState: SetupStatusState = {
  loadSetupStatusResponse: undefined
};

export const reducer = createReducer(
  initialState,
  on(actions.loadSetupStatusSuccess, (state, action) => ({
    ...state,
    loadSetupStatusResponse: action.response
  }))
);

export const getIsSetupStatus = (state: SetupStatusState) => state.loadSetupStatusResponse;
